import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  BehaviorSubject,
  catchError,
  delay,
  Observable,
  of,
  tap,
  throwError,
} from 'rxjs';
import { getParams } from '@pinup-teams/common';
import { environment } from '@fb/environments';

import { ITSupportRequest } from '../../models/it-support.model';
import { IssueType } from '../../models/issues-type.model';
import { getIssueTypes } from './mocks/it-support-dialog.mock';

@Injectable()
export class ItSupportDialogService {
  #httpClient = inject(HttpClient);

  isLoading = new BehaviorSubject(false);

  getIssueTypes(): Observable<IssueType[]> {
    this.isLoading.next(true);

    if (environment.useMocks) {
      return of(getIssueTypes()).pipe(
        delay(500),
        tap(() => this.isLoading.next(false)),
      );
    }

    return this.#httpClient
      .get<
        IssueType[]
      >(`${environment.apiHost}jira-integration/projects/issue-fields/`)
      .pipe(
        tap(() => this.isLoading.next(false)),
        catchError((error) => {
          this.isLoading.next(false);

          return throwError(() => error);
        }),
      );
  }

  sendRequest(payload: ITSupportRequest): Observable<void> {
    this.isLoading.next(true);

    if (environment.useMocks) {
      return of(null).pipe(
        delay(500),
        tap(() => this.isLoading.next(false)),
      );
    }

    return this.#httpClient
      .post<void>(
        `${environment.apiHost}support/it-requests/`,
        getParams(payload),
      )
      .pipe(
        tap(() => this.isLoading.next(false)),
        catchError((error) => {
          this.isLoading.next(false);

          return throwError(() => error);
        }),
      );
  }
}
